export default __webpack_public_path__ + "static/media/ray5.0a941763.png";